let error = false;
document.addEventListener("DOMContentLoaded", function () {
  const multi7Box = document.querySelector(".box-wrapper.multi-7");
 const monobloc_option_wrapper = document.querySelector(".monobloc-option-wrapper");
  // Hide by default
  multi7Box.style.display = "none";
  monobloc_option_wrapper.style.display = "none";

  // All radio buttons in Volet section
  const voletRadios = document.querySelectorAll('.three-bc .input-radio');

  voletRadios.forEach(radio => {
    
    radio.addEventListener("change", function () {


       const formRow = this.closest('.form-row');
    formRow.querySelectorAll('.hide').forEach(el => {
      el.style.display = "none";
    });
    const label = document.querySelector(`label[for="${this.id}"]`);
    const container = this.closest('.three-bc-inner');

    // Find the .hide element within this container
    const hiddenEl = container.querySelector('.hide');
    if (hiddenEl) {
      hiddenEl.style.display = "block";
    }


      if (this.value.toLowerCase().includes("volet roulant")) {
        // Show multi-7 box
        multi7Box.style.display = "block";
         monobloc_option_wrapper.style.display = "none";
         $('#v-input-box').val(0);
        multi7Box.querySelector("#v-btn-plus").click();
        const inputBox = multi7Box.querySelector("#v-input-box");
      
       
 
        // Add 'required' to all form fields inside
        multi7Box.querySelectorAll("input, select, textarea").forEach(el => {
          el.setAttribute("required", "required");
        });
      } 
      else if(this.value.toLowerCase().includes("monobloc")){
            multi7Box.style.display = "none";
             monobloc_option_wrapper.style.display = "block";
      }
      else {
        // Hide multi-7 box
         multi7Box.style.display = "none";
         monobloc_option_wrapper.style.display = "none";
        // Remove 'required' from all form fields inside
        multi7Box.querySelectorAll("input, select, textarea").forEach(el => {
          el.removeAttribute("required");
        });
      }


    
   



    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const porteOptions = document.querySelectorAll(".porte-options");
  const inputPortes = document.querySelectorAll(".input-porte");
  const nonPortes = document.querySelectorAll(".non-porte");

  // Hide initially
  porteOptions.forEach(option => {
    option.style.display = "none";
  });

  // Show on .input-porte click/change
  inputPortes.forEach(input => {
    input.addEventListener("change", function () {
      porteOptions.forEach(option => {
        option.style.display = "block";
      });
    });
  });

  // Hide on .non-porte click/change
  nonPortes.forEach(input => {
    input.addEventListener("change", function () {
      porteOptions.forEach(option => {
        option.style.display = "none";
      });
    });
  });

});

document.querySelectorAll('.scrolltop.action-button').forEach(button => {
  button.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const vantauxOptions = document.querySelectorAll(".vantaux-option");
  const inputVantaux = document.querySelectorAll(".input-vantaux");
  const nonVantaux = document.querySelectorAll(".non-vantaux");

  // Initially hide vantaux options
  vantauxOptions.forEach(option => {
    option.style.display = "none";
  });

  // Show vantaux options when input-vantaux is selected
  inputVantaux.forEach(input => {
    input.addEventListener("change", function () {
      vantauxOptions.forEach(option => {
        option.style.display = "block";
      });
    });
  });

  // Hide vantaux options when non-vantaux is selected
  nonVantaux.forEach(input => {
    input.addEventListener("change", function () {
      vantauxOptions.forEach(option => {
        option.style.display = "none";
      });
    });
  });
});




function navigateSlides(currentSlide, nextSlide) {
    $("#progress_header li").eq($(".multistep-box").index(nextSlide)).addClass("active");
    currentSlide.hide();
    nextSlide.show();
   window.scrollTo({ top: 0, behavior: 'smooth' });
}

// $(".fs_next_btn, .ss_next_btn, .ts_next_btn").click(function() {
//      var currentStep = $(this).closest(".multistep-box");
//         var allFilled = true;
//          currentStep.find("input[type='radio'], input[type='text'], input[type='number']").each(function() {
//            if ($(this).is(":radio")) {
//             var name = $(this).attr("name");
//             if ($("input[name='" + name + "']:checked").length === 0) {
//                 allFilled = false;
//               console.log(name);
//             }
//            }
//             else if ($(this).is(":file")) { 
//                 if ($(this).prop("files").length === 0) {
//                     console.log("File input is empty");
//                     allFilled = false;
//                 }
//             }
//            else
//            {
//               if ($(this).val().trim() === "") {
//                     allFilled = false;
//                       console.log('text');
//                 }
//            }           
//         });
//         if (allFilled) {
//             let currentSlide = $(this).closest('.multistep-box');
//             let nextSlide = currentSlide.next();
//             navigateSlides(currentSlide, nextSlide);
//         } else {
//           currentStep.find('.message-wrapper').addClass('active');
//         }
  

// });




$(".fs_next_btn, .ss_next_btn, .ts_next_btn").click(function() {
    var currentStep = $(this).closest(".multistep-box");
    var allFilled = true;
    
    currentStep.find("input[required]").each(function() {
        if ($(this).is(":radio")) {
            var name = $(this).attr("name");
            if ($("input[name='" + name + "']:checked").length === 0) {
                allFilled = false;
                console.log(name);
            }
        } else if ($(this).is(":file")) {
            if ($(this).prop("files").length === 0) {
                console.log("File input is empty");
                allFilled = false;
            }
        } else {
            if ($(this).val().trim() === "") {
                allFilled = false;
                console.log('text');
            }
        }
    });

    if (allFilled) {
        let currentSlide = $(this).closest('.multistep-box');
        let nextSlide = currentSlide.next();
        navigateSlides(currentSlide, nextSlide);
    } else {
        currentStep.find('.message-wrapper').addClass('active');
    }
});




$(".previous").click(function() {
    let currentSlide = $(this).closest('.multistep-box');
    let previousSlide = currentSlide.prev();
    $("#progress_header li").eq($(".multistep-box").index(currentSlide)).removeClass("active");
    currentSlide.hide();
    previousSlide.show();
});

$(".submit_btn").click(function() {
    if (!error) {
        $(".main").addClass("form_submitted");
    }
    return false;
});







// const actualBtn = document.getElementById('actual-btn');
// const fileChosen = document.getElementById('file-chosen');
// const fileUrlInput = document.getElementById('file-url');
// const fileUrlDoc = document.getElementById('file-doc-link');

// actualBtn.addEventListener('change', function() {
//     const file = this.files[0];
//     fileChosen.textContent = file.name;

//     const formData = new FormData();
//     formData.append('file', file);

//     fetch('https://rentside.website/invoice/file-upload', {
//         method: 'POST',
//         body: formData,
//         redirect: 'follow',  // Ensures fetch will follow the redirect
//         headers: {
//             'Accept': 'application/json',
//         }
//     })
//     .then(response => {
//         if (response.ok) {
//             return response.json();
//         } else if (response.status === 302) {
//             // Handle redirect explicitly if needed
//             return fetch(response.url, {
//                 method: 'GET',
//                 headers: {
//                     'Accept': 'application/json',
//                 }
//             }).then(redirectResponse => redirectResponse.json());
//         } else {
//             throw new Error('File upload failed');
//         }
//     })
//     .then(data => {
//         if (data && data.url) {
//             fileUrlDoc.value = data.url;
//         } else {
//             console.error('Response does not contain URL.');
//         }
//     })
//     .catch(error => {
//         console.error('Error uploading file:', error);
//     });
// });

const actualBtn = document.getElementById('actual-btn');
const fileChosen = document.getElementById('file-chosen');
const fileUrlDoc = document.getElementById('file-doc-link');
const overlay = document.getElementById('upload-overlay');

actualBtn.addEventListener('change', function () {
    const file = this.files[0];
    fileChosen.textContent = file.name;

    const formData = new FormData();
    formData.append('file', file);

    // ✅ Show fullscreen loader
    overlay.style.display = 'flex';

    fetch('https://rentside.website/invoice/file-upload', {
        method: 'POST',
        body: formData,
        redirect: 'follow',
        headers: {
            'Accept': 'application/json',
        }
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else if (response.status === 302) {
                return fetch(response.url, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                }).then(redirectResponse => redirectResponse.json());
            } else {
                throw new Error('File upload failed');
            }
        })
        .then(data => {
            if (data && data.url) {
                fileUrlDoc.value = data.url;

                // ✅ If file is PDF → clear, remove required, disable all fields in .form-data-container
              if (file) {
                      document.querySelectorAll(
                          '.form-data-container input:not([type="file"]):not(#file-doc-link), .form-data-container select, .form-data-container textarea'
                      ).forEach(el => {
                          el.value = "";              // clear value
                          el.checked = false;         // uncheck radios/checkboxes
                          el.removeAttribute('required'); // remove required
                      });
                  }

                // ✅ Auto-click Next button
                const nextBtn = document.querySelector('.form-data-container .fs_next_btn');
                const action_button = document.querySelector('.action-submit-button');
                if (action_button) {
                   
                     document.querySelectorAll(
        '.address-data-container input:not([type="file"]):not(#file-doc-link), .address-data-container select, .address-data-container textarea'
    ).forEach(el => {
        el.value = "";              // clear value
        el.checked = false;         // uncheck radios/checkboxes
        el.removeAttribute('required'); // remove required
    });


                    action_button.click();
                }
                // if (nextBtn) {
                //     nextBtn.click();
                // }
                document.querySelectorAll('.secondary-address-option input[type="radio"]').forEach(radio => {
                  radio.checked = false;
                });
            } else {
                console.error('Response does not contain URL.');
            }
        })
        .catch(error => {
            console.error('Error uploading file:', error);
            alert("File upload failed. Please try again.");
        })
        .finally(() => {
            // ✅ Hide overlay when upload finishes
            overlay.style.display = 'none';
        });
});

$(document).ready(function() {
    // Function to replace French characters with English equivalents in the name attribute
    function replaceFrenchCharacters(str) {
      const replacements = {
        'é': 'e',
        'è': 'e',
        'ê': 'e',
        'ë': 'e',
        'à': 'a',
        'â': 'a',
        'ç': 'c',
        'î': 'i',
        'ï': 'i',
        'ô': 'o',
        'ù': 'u',
        'û': 'u',
        'ü': 'u',
        // Add more replacements as needed
      };

      return str.replace(/[éèêëàâçîïôùûü]/g, function(match) {
        return replacements[match] || match;
      });
    }

    // Function to update input name attributes
    function updateInputNames() {
      $('input[name]').each(function() {
        let currentName = $(this).attr('name');
        let updatedName = replaceFrenchCharacters(currentName);
        if (currentName !== updatedName) {
          $(this).attr('name', updatedName);
        }
      });
    }

    // Update input name attributes on page load
    updateInputNames();

    // Optionally, update input name attributes when input fields are added dynamically
    $(document).on('DOMNodeInserted', 'input[name]', function() {
      let currentName = $(this).attr('name');
      let updatedName = replaceFrenchCharacters(currentName);
      if (currentName !== updatedName) {
        $(this).attr('name', updatedName);
      }
    });
  });
$(document).ready(function() {
    $('.multistep-form input').each(function() {
        var originalName = $(this).attr('name');
        if (originalName) {
            var cleanedName = originalName.replace(/[^\w\[\]\s]/g, ''); // Include \s to preserve spaces
            $(this).attr('name', cleanedName);
        }
    });


$('.verre-input-1 input').on('change', function () {
    const selectedId = $(this).attr('id');
   $('.window-color-swatch, .windows-colors, .windows-colors-1').find('input').val(''); 
    // Hide all .extradiv elements
    $('.window-color-swatch').addClass('d-none');
    $('.windows-colors').addClass('d-none');
    $('.windows-colors-1').addClass('d-none');

    // Show only the corresponding one
  if(selectedId === 'Fabrication'){
     $('.windows-colors-1').removeClass('d-none');
  } 
  if(selectedId === 'Je-ne-sais-pas'){
     $('.windows-colors').removeClass('d-none');
  }
  if (selectedId === 'Tableau') {
         $('.window-color-swatch').removeClass('d-none');
    } 


  
  });
  
});
$(document).ready(function() {
    $('#f-input-box').val();
    function createWindowField(index) {
         const required = index === 1 ? 'required' : '';
        return `
        <div class="row-col" id="window-${index}">
            <h3>Fenêtre #${index}</h3>
            <div class="row-col-form">
                <input type="number" step="any" min="0" name="contact[Fenetre #${index} Hauteur (cm)]" id="Hauteur${index}" class="input-text" placeholder="Hauteur (cm)">
                <input type="number" step="any" min="0"  name="contact[Fenetre #${index} Largeur (cm)]" id="Largeur${index}" class="input-text" placeholder="Largeur (cm)" >
               <input type="number"  step="any" min="0"  name="contact[Quantite #${index}]"  id="Quantite{index}"  class="input-text" placeholder="Quantité" >

            </div>
        </div>`;
    }
    function updateWindowFields() {
        let quantity = parseInt($('#f-input-box').val());
        let container = $('#windows-container');
        container.empty();
        for (let i = 1; i <= quantity; i++) {
            container.append(createWindowField(i));
        }
    }
    updateWindowFields();
    $('#f-btn-plus').on('click', function() {
        let quantityInput = $('#f-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity < parseInt(quantityInput.attr('max'))) {
            quantityInput.val(quantity + 1);
            updateWindowFields();
        }
    });
    $('#f-btn-minus').on('click', function() {
        let quantityInput = $('#f-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity > parseInt(quantityInput.attr('min'))) {
            quantityInput.val(quantity - 1);
            updateWindowFields();
        }
    });
    $('#f-input-box').on('input', function() {
        let quantityInput = $(this);
        let quantity = parseInt(quantityInput.val());
        if (quantity >= parseInt(quantityInput.attr('min')) && quantity <= parseInt(quantityInput.attr('max'))) {
            updateWindowFields();
        } else {
            // Reset to closest valid value
            if (quantity < parseInt(quantityInput.attr('min'))) {
                quantityInput.val(quantityInput.attr('min'));
            } else if (quantity > parseInt(quantityInput.attr('max'))) {
                quantityInput.val(quantityInput.attr('max'));
            }
            updateWindowFields();
        }
    });
});
$(document).ready(function() {
    function createWindowField2(index) {
        return `
        <div class="row-col" id="window-volet-${index}">
            <h3>Volet #${index}</h3>
            <div class="row-col-form">
                <input type="number" min="0"  step="any" name="contact[Volet #${index} Hauteur (cm)]" id="Hauteur${index}" class="input-text" placeholder="Hauteur (cm)" required>
                <input type="number" min="0"  step="any" name="contact[Volet #${index} Largeur (cm)]" id="Largeur${index}" class="input-text" placeholder="Largeur (cm)" required>
            </div>
        </div>`;
    }
    function updateWindowFields2() {
        let quantity = parseInt($('#v-input-box').val());
        let container = $('#windows-container-2');
        container.empty();
        for (let i = 1; i <= quantity; i++) {
            container.append(createWindowField2(i));
        }
    }
     function updateWindowFields3() {
        let quantity = parseInt($('#v-input-box').val());
        let container = $('#windows-container-2');
        container.empty();
         container.append(createWindowField2(1));
        
    }
    updateWindowFields2();
    $('#v-btn-plus').on('click', function() {
        let quantityInput = $('#v-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity < parseInt(quantityInput.attr('max'))) {
            quantityInput.val(quantity + 1);
            updateWindowFields2();
        }
    });
    $('#v-btn-minus').on('click', function() {
        let quantityInput = $('#v-input-box');
        let quantity = parseInt(quantityInput.val());
        if (quantity > parseInt(quantityInput.attr('min'))) {
            quantityInput.val(quantity - 1);
            updateWindowFields2();
        }
    });
    $('#v-input-box').on('input', function() {
        let quantityInput = $(this);
        let quantity = parseInt(quantityInput.val());
        if (quantity >= parseInt(quantityInput.attr('min')) && quantity <= parseInt(quantityInput.attr('max'))) {
            updateWindowFields2();
        } else {
            // Reset to closest valid value
            if (quantity < parseInt(quantityInput.attr('min'))) {
                quantityInput.val(quantityInput.attr('min'));
            } else if (quantity > parseInt(quantityInput.attr('max'))) {
                quantityInput.val(quantityInput.attr('max'));
            }
            updateWindowFields2();
        }
    });


$('.secondary-add-option input').on('change', function() {
    if ($('.secondary-add-option input:checked').val() === 'OUI') {
        $('.secondary-address').show();
              $('.secondary-address :input').not('[type="email"]').attr('required', true);
    } else {
       $('.secondary-address :input').removeAttr('required');
        $('.secondary-address').hide();
    }
});


  
});


// $(document).ready(function () {
//     $('#multistep_form').submit(function (e) {
//         e.preventDefault(); // Stop default form submission

//         $.ajax({
//             type: 'POST',
//             url: 'https://rentside.website/invoice/window', 
//             data: $(this).serialize(),
//             success: function (response) {
//                 // Hide form and show success message
//                 $('#multistep_form').hide();
//                 $('.window-success').show();
//                 window.scrollTo(0, 0);
//             },
//             error: function (error) {
//                 alert('There was some Error');
//                 console.error(error);
//             }
//         });

//         return false; // Not strictly necessary due to e.preventDefault(), but added for extra safety
//     });
// });



$(document).ready(function () {
    $('#multistep_form').submit(function (e) {
        e.preventDefault(); // Stop default form submission

        // Get form data normally
        let formData = $(this).serializeArray();

        // Get all drafts from localStorage
        let drafts = JSON.parse(localStorage.getItem("form_drafts")) || [];

        // Append drafts into formData (same key name "drafts[]")
        drafts.forEach((draft, i) => {
            formData.push({
                name: "drafts[" + i + "][time]",
                value: draft.time
            });
            Object.keys(draft.data).forEach(key => {
                let value = draft.data[key];
                if (Array.isArray(value)) {
                    value.forEach(v => {
                        formData.push({
                            name: "drafts[" + i + "][data][" + key + "][]",
                            value: v
                        });
                    });
                } else {
                    formData.push({
                        name: "drafts[" + i + "][data][" + key + "]",
                        value: value
                    });
                }
            });
        });

formData = formData.filter(function(field) {
    return field.value !== null && field.value.trim() !== '';
});

$.ajax({
    type: 'POST',
    url: 'https://rentside.website/invoice/window',
    data: $.param(formData), // convert to query string
    success: function (response) {
        // ✅ Clear drafts after successful submit
        localStorage.removeItem("form_drafts");
        $('#saved_drafts').empty(); // clear UI

        $('#multistep_form').hide();
        $('.window-success').show();
        window.scrollTo(0, 0);
    },
    error: function (error) {
        alert('There was some Error');
        console.error(error);
    }
});

        return false;
    });
});


(function() {
  const form = document.getElementById("multistep_form");
  const saveBtn = document.querySelector("input[name='scrolltop']");
  const draftsContainer = document.getElementById("saved_drafts");
  const draftsHeading = document.querySelector(".save_draft_heading");
  const STORAGE_KEY = "form_drafts";

  let drafts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  renderDrafts();



  // Save current form data
  saveBtn.addEventListener("click", function() {
    const formData = {};
    const elements = form.querySelectorAll("input, textarea, select");

    elements.forEach(el => {
      if (el.type === "radio") {
        if (el.checked) formData[el.name] = el.value;
      } 
      else if (el.type === "checkbox") {
        if (!formData[el.name]) formData[el.name] = [];
        if (el.checked) formData[el.name].push(el.value);
      } 
      else {
        formData[el.name] = el.value;
      }
    });

    const timestamp = new Date().toLocaleString();
    drafts.push({ data: formData, time: timestamp });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
    renderDrafts();
 
        const form2 = document.getElementById("multistep_form");
        form2.reset(); // reset input values
        $('.window-success').hide(); // hide success message
        $('#multistep_form').show(); // show form again
  });

  // Render draft cards
  function renderDrafts() {
      if (drafts.length > 0) {
        draftsHeading.style.display = "block";
      } else {
        draftsHeading.style.display = "none";
      }

    draftsContainer.innerHTML = "";
    drafts.forEach((draft, index) => {
      const row = document.createElement("div");
      row.className = "draft-card";
      row.innerHTML = `
        <span class="draft-info">Type de Fenêtres ${index + 1} enregistré</span>
        <div class="draft-actions">
          
          <button type="button" class="delete-btn" data-index="${index}">Supprimer</button>
        </div>
      `;
      draftsContainer.appendChild(row);
    });

    // Attach load event
    draftsContainer.querySelectorAll(".load-btn").forEach(btn => {
      btn.addEventListener("click", function() {
        const idx = this.dataset.index;
        populateForm(drafts[idx].data);
      });
    });

    // Attach delete event
    draftsContainer.querySelectorAll(".delete-btn").forEach(btn => {
      btn.addEventListener("click", function() {
        const idx = this.dataset.index;
        drafts.splice(idx, 1);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
        renderDrafts();
      });
    });




  }

  // Populate form with saved draft
  function populateForm(data) {
    const elements = form.querySelectorAll("input, textarea, select");

    elements.forEach(el => {
      if (!(el.name in data)) return;

      if (el.type === "radio") {
        el.checked = (data[el.name] === el.value);
      } 
      else if (el.type === "checkbox") {
        el.checked = data[el.name].includes(el.value);
      } 
      else {
        el.value = data[el.name];
      }
    });

  }


   

  
})();


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    console.log('ttttt');
  document.querySelectorAll("input[type='radio']").forEach(radio => {
    const group = document.getElementsByName(radio.name);
    if (group.length > 0) {
      const anyChecked = Array.from(group).some(r => r.checked);
      if (!anyChecked) {
        group[0].checked = true; 
      }
    }
  });
  // Handle checkboxes (by name group, same logic)
  const checkGroups = {};
  document.querySelectorAll("input[type='checkbox']").forEach(cb => {
    if (!checkGroups[cb.name]) {
      checkGroups[cb.name] = [];
    }
    checkGroups[cb.name].push(cb);
  });

  Object.values(checkGroups).forEach(group => {
    const anyChecked = group.some(cb => cb.checked);
    if (!anyChecked) {
      group[0].checked = true;
    }
  });



if ($("#option1").is(":checked")) {
        $(".vantaux-option").show();
        $("#bc5-poignee-simple").click();
         const firstInput = document.querySelector(".three-bc-inner input[type='radio']");
        if (firstInput) {
          firstInput.click(); 
        }
    } else {
      $(".vantaux-option").hide();
    }


  document.querySelectorAll('.secondary-address-option input[type="radio"]').forEach(radio => {
  radio.checked = false;
});
    




   }, 2000);




});



document.addEventListener("DOMContentLoaded", function () {
  var carousel = document.querySelector('.form-carousel');
  if (!carousel) return;

  // Watch for changes in selected slide
  const observer = new MutationObserver(() => {
    const selectedCell = carousel.querySelector('.carousel-cell-form-1.is-selected');
    if (selectedCell) {
      const radio = selectedCell.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
         let radios = document.querySelectorAll(".box-container.bc5 input[type='radio']");
        if (radios.length > 0) {
          radios.forEach(r => r.checked = false); // clear all
          radios[0].checked = true; // check first
        }
      }
    }
  });

  // Observe only attribute/class changes
  observer.observe(carousel, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class"]
  });

  // Run once on load
  const initial = carousel.querySelector('.carousel-cell-form-1.is-selected input[type="radio"]');
  if (initial) initial.checked = true;

});